// @flow

import type {Language, Notification, User} from '@/types'

import React from 'react'
import {connect} from 'react-redux'
import {mergeAll} from 'ramda'
import GoHome from 'react-icons/lib/go/home'
import logout from '@/logout'
import {appActions, appSelectors, uiActions} from '@/store'
import {translationSupportedLanguages} from '../util'

import Logo from '@/elements/logo'
import Notifications from './notifications'
import CountrySelect from '@/controls/country-select'
import idleLogout from '@/idle-logout'

import './index.css'

type Props = {
  l: Language,
  notifications: Array<Notification>,
  setActiveTab: (string) => void,
  user: User,
  saveLanguagePreference: (string) => void,
  fetchHomePageUrl: () => void,
}

const onLanguageSelect = ({saveLanguagePreference}) => (lang) => saveLanguagePreference(lang)

export const RawHeaderAction = (props: Props) => {
  idleLogout(1000 * 60 * 60 * 4, props.user.homeUrl)
  return (
    <div>
      <div className="row">
        <div className="col-xs-5">
          <Logo onClick={props.fetchHomePageUrl}/>
        </div>
        <div className="col-xs-7">
          <div className="info-header">
            <ul className="user-details list-inline">
              <li className="title">{props.l('Monitoring')} </li>
              <li className="underline">
                <a onClick={props.fetchHomePageUrl}><GoHome /></a>
              </li>
              <li className="underline">/</li>
              <li className="underline"><b>{props.l('ID')}</b> {props.user.userId}</li>
              <li className="underline">/</li>
              <li className="underline language-select"><CountrySelect
                selected={props.user.languageCode === 'EN' ? 'GB' : (props.user.languageCode || 'GB')}
                availableCountries={translationSupportedLanguages}
                allOption={false}
                onChange={onLanguageSelect(props)}
              /></li>
              <li className="underline">/</li>
              <li className="underline">
                <a
                  onClick={() => logout(window.location, props.user.homeUrl)}
                >
                  {props.l('Logout')}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <ul className="list-inline header-action">
        <li>
          <Notifications notifications={props.notifications} l={props.l} langCode={props.user.preferredLanguageCode}/>
        </li>
      </ul>
    </div>)
}

const mapStateToProps = (state) => ({
  notifications: appSelectors.getNotifications(state),
  user: state.app.user,
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
  mergeAll([appActions, uiActions]),
)(RawHeaderAction)



// WEBPACK FOOTER //
// ./src/views/header/index.js